import { Link } from 'react-router';
import { cn } from '@/lib/utils';

interface PageNotFoundProps {
  /**
   * Whether to fill the viewport. True for the catch-all route, which has no
   * layout around it; false when rendered *inside* the public layout — a
   * full-height 404 between a header and a footer pushes the footer a screen
   * down. Named after `ErrorBoundary`'s prop, which draws the same distinction.
   */
  fullScreen?: boolean;
}

export function PageNotFound({ fullScreen = true }: PageNotFoundProps) {
  return (
    <div
      className={cn(
        'tw:flex tw:flex-col tw:items-center tw:justify-center tw:bg-ed-cream tw:px-6 tw:text-center',
        fullScreen ? 'tw:min-h-screen' : 'tw:py-28',
      )}
    >
      <p className='tw:font-serif tw:text-6xl tw:text-ed-gold'>404</p>
      <h1 className='tw:mt-4 tw:font-serif tw:text-3xl tw:font-light'>Page not found</h1>
      <p className='tw:mt-2 tw:text-ed-charcoal/70'>The page you&rsquo;re looking for doesn&rsquo;t exist.</p>
      <Link
        to='/'
        className='tw:mt-8 tw:border tw:border-ed-black tw:px-6 tw:py-3 tw:text-xs tw:tracking-[0.2em] tw:uppercase tw:transition-colors tw:hover:bg-ed-black tw:hover:text-ed-cream'
      >
        Return home
      </Link>
    </div>
  );
}
